export const FINAL_PLAN = {
    1: 'PlanFinal_v3',
    2: 'PlanFinal_v4',
    DEFAULT: 'PlanFinal_v4'
}

export const FINAL_PLAN_CONTENT = {
    1: 'upsell_v3',
    2: 'upsell_v4',
    default: 'upsell_v4'
}
